export enum CountriesMutationTypes {
    SET_COUNTRIES = 'SET_COUNTRIES',
    SET_COUNTRY_CODE = 'SET_COUNTRY_CODE',
    SET_COMPANY_INFO = 'SET_COMPANY_INFO'
  }
  